import { BUNDLE_SMALL_NAME, getOneBundleByInstant } from "../../../modes/normalMode/BundleResourceConfig";
import { pawnShopGameObjI } from "./const/pawnShopConst";

const {ccclass, property} = cc._decorator;

@ccclass
export default class pawnShopGameResultItem extends cc.Component {

    obj:pawnShopGameObjI = null;

    @property({type:cc.Label,displayName:"名字文本"})
    lbName:cc.Label = null;

    @property({type:cc.Sprite,displayName:"显示图片"})
    sp:cc.Sprite = null;

    bindData(obj:pawnShopGameObjI){
        this.obj = obj;
        this.loadSprite();
        this.lbName.string = obj.name;
    }

    //加载图片
    loadSprite(){
        getOneBundleByInstant(BUNDLE_SMALL_NAME.pawnShopGameBundle).load(`assets/pawnShopGame/obj/${this.obj.name}`,cc.SpriteFrame,(err,spr:cc.SpriteFrame)=>{
            if(err){
                console.error(err,"#pawnShopGameResultItem.ts 27 loadSprite fail ");
            }
            this.sp.spriteFrame = spr;
        });
    }

}
